import {
  AddButton,
  FormSection,
  Select,
  TextField,
  Tooltip,
  Modal,
  Button,
  TrashButton,
  Checkbox,
  // DatePicker,
} from "components/Core"
import { Controller } from "react-hook-form"
import { SHIPPING_TYPES } from "constants/FORM_CONSTANTS"
import BadgeAlertForm from "components/Core/Form/BadgeAlertForm"
import { IoSearch } from "react-icons/io5"
import useSearchMiddlewareOSRM from "hooks/useSearchMiddlewareOSRM"
import { useEffect, useState, useRef, Fragment } from "react"
import Swal from "sweetalert2"
import cn from "classnames"
import usePreRender from "hooks/usePreRender"
import CriteriasScheduleOrder from "components/Custom/CriteriasScheduleOrder"

interface IFormQuerySchedule {
  is_edit?: boolean
  control: any
  errors: any
  watch: any
  setValue: any
}

const FormQuerySchedule = ({ control, errors, watch, setValue }: IFormQuerySchedule) => {
  const { _color } = usePreRender()
  const modal_ref = useRef<any>(null)
  const check_query_ref = useRef<any>(null)
  //const check_simulated_date_ref = useRef<any>(null)
  const [channels, set_channels] = useState([])
  const [sources, set_sources] = useState([])
  const [loading_schedule, set_loading_schedule] = useState<boolean>(false)
  const [selected_items, set_selected_items] = useState<Array<any>>([])
  const [available_items, set_available_items] = useState([])
  const { data: data_channels, search_osrm_action: search_osrm_action_channels } = useSearchMiddlewareOSRM({
    entity: "channels",
  })
  const { data: data_sources, search_osrm_action: search_osrm_action_sources } = useSearchMiddlewareOSRM({
    entity: "sources",
  })
  const { action_search_osrm_action } = useSearchMiddlewareOSRM({
    entity: "items",
  })
  const items_query = watch("items_query")
  const find_by_sku = watch("find_by_sku")
  const shippingTypeSelected = watch("shippingType")
  // const enableSimulatedDate = watch("enableSimulatedDate")

  useEffect(() => {
    search_osrm_action_channels({ from: 0, size: 1000, fields: ["id", "name"] })
    search_osrm_action_sources({ from: 0, size: 1000, fields: ["id", "name"] })
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    const get_channels_action = async () => {
      try {
        let channels_from_req = data_channels?.records
        set_channels(
          channels_from_req?.map((chl: any) => ({
            id: chl?.id,
            label: `${chl?.id} -> "${chl?.name}"`,
            value: chl?.id,
          })),
        )
      } catch (error: any) {
        Swal.fire({
          title: "Error",
          text: JSON.stringify(error?.response?.data?.message),
          icon: "error",
        })
      }
    }
    const get_sources_action = async () => {
      try {
        let sources_from_req = data_sources?.records

        let result = sources_from_req || []
        result = result?.sort((a: any, b: any) => a?.name.localeCompare(b?.name))

        set_sources(
          result?.map((src: any) => ({
            id: src?.id,
            label: `${src?.id} -> "${src?.name}"`,
            value: src?.id,
          })),
        )
      } catch (error: any) {
        Swal.fire({
          title: "Error",
          text: JSON.stringify(error?.response?.data?.message),
          icon: "error",
        })
      }
    }
    get_sources_action()
    get_channels_action()
    // eslint-disable-next-line
  }, [data_channels, data_sources])

  useEffect(() => {
    setValue("items", selected_items)
    // eslint-disable-next-line
  }, [selected_items])

  const find_items_action = async () => {
    try {
      set_available_items([])
      set_loading_schedule(true)
      modal_ref.current?.open()
      let _params: any = {
        from: 0,
        size: 1000,
        fields: ["sku", "name"],
      }
      if (find_by_sku) {
        Object.assign(_params, {
          filters: {
            sku: items_query,
          },
        })
      } else {
        Object.assign(_params, {
          queryString: items_query,
        })
      }
      const res: any = await action_search_osrm_action("items", _params)
      if (Boolean(res?.data?.message?.size)) {
        const items = res.data.message.records.map((item: any) => ({
          sku: item?.sku,
          name: item?.name,
          quantity: 1,
        }))
        set_available_items(items)
      } else {
        set_available_items([])
      }
      set_loading_schedule(false)
    } catch (error: any) {
      Swal.fire({
        title: "Error",
        text: JSON.stringify(error?.response?.data?.message),
        icon: "error",
      })
      set_loading_schedule(false)
    }
  }

  const validationsSectionsErrors = {
    1: Boolean(["shippingType", "channel"].some((key: string) => Object.keys(errors).includes(key))),
    2: Boolean(["shippingAddress", "contact"].some((key: string) => Object.keys(errors).includes(key))),
    3: Boolean(["items"].some((key: string) => Object.keys(errors).includes(key))),
  }

  const add_item_form = (item: any) => {
    set_selected_items([...selected_items, item])
  }

  const delete_item_form = (item: any) => {
    const updated_items = selected_items.filter((_item: any) => _item.sku !== item.sku)
    set_selected_items(updated_items)
  }

  const add_qty_item_form = (item: any, _qty: number) => {
    const updated_items = selected_items.map((_item: any) => {
      if (_item.sku === item.sku) {
        return { ..._item, quantity: _qty }
      }
      return _item
    })
    set_selected_items(updated_items)
  }

  console.log("errors", errors)

  return (
    <Fragment>
      <div className="w-full flex flex-col items-center gap-4">
        <FormSection
          title="Información general"
          helperText="Información general"
          number={1}
          anyError={validationsSectionsErrors[1]}
          closed={false}
        >
          <div className="w-full flex flex-col gap-4 lg:px-16 lg:py-10">
            <div className="w-full flex flex-col lg:flex-row gap-4">
              <Controller
                name="shippingType"
                control={control}
                defaultValue={[]}
                render={({ field: { onChange, value } }) => (
                  <Select label="Tipo de envío" options={SHIPPING_TYPES} onChange={onChange} value={value} multi />
                )}
              />
              <Controller
                name="channel"
                control={control}
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <Select label="Canal" options={channels} onChange={onChange} value={value} withSearch />
                )}
              />
            </div>
            {shippingTypeSelected?.includes("SP") ? (
              <div className="flex flex-col lg:flex-row gap-4">
                <Controller
                  name="storePickupId"
                  control={control}
                  defaultValue=""
                  render={({ field: { onChange, value } }) => (
                    <Select label="Id Tienda/Bodega" options={sources} onChange={onChange} value={value} withSearch />
                  )}
                />
              </div>
            ) : null}
            {/* <div className="flex flex-row items-center justify-start mt-2 ml-1">
              <Controller
                name="enableSimulatedDate"
                control={control}
                defaultValue={false}
                render={({ field: { onChange, value } }) => (
                  <Checkbox
                    ref={check_simulated_date_ref}
                    name="enableSimulatedDate"
                    onSelect={onChange}
                    checked={value}
                  />
                )}
              />
              <label
                className="ml-2 text-sm text-gray-700 cursor-pointer"
                onClick={() => check_simulated_date_ref?.current?.click()}
              >
                Simular fecha de consulta
              </label>
            </div> */}
            {/* {enableSimulatedDate ? (
              <Controller
                name="simulatedDateValue"
                control={control}
                defaultValue=""
                render={({ field: { onChange } }) => (
                  <DatePicker onChange={onChange} label="Fecha de consulta simulada" />
                )}
              />
            ) : null} */}
            {validationsSectionsErrors[1] ? <BadgeAlertForm /> : null}
          </div>
        </FormSection>
        <FormSection
          title="Datos de envío"
          helperText="Datos de envío"
          number={2}
          anyError={validationsSectionsErrors[2]}
          closed={false}
        >
          <div className="w-full flex flex-col gap-4 lg:px-16 lg:py-10">
            <CriteriasScheduleOrder control={control} errors={errors} setValue={setValue} watch={watch} />
            <div className="w-full flex flex-col lg:flex-row gap-4">
              <Controller
                name="shippingAddress.location.latitude"
                control={control}
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <TextField label="Latitud (Opcional)" onChange={onChange} value={value} />
                )}
              />
              <Controller
                name="shippingAddress.location.longitude"
                control={control}
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <TextField label="Longitud (Opcional)" onChange={onChange} value={value} />
                )}
              />
            </div>
            <Controller
              name="shippingAddress.address"
              control={control}
              defaultValue=""
              render={({ field: { onChange, value } }) => (
                <TextField label="Dirección (Opcional)" onChange={onChange} value={value} />
              )}
            />
            <div className="w-full flex flex-col lg:flex-row gap-4">
              <Controller
                name="contact.name"
                control={control}
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <TextField label="Nombre de contacto (Opcional)" onChange={onChange} value={value} />
                )}
              />
              <Controller
                name="contact.phone"
                control={control}
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label="Teléfono de contacto (Opcional)"
                    onChange={onChange}
                    value={value}
                    type="number"
                    min={0}
                  />
                )}
              />
            </div>
            <Controller
              name="contact.email"
              control={control}
              defaultValue=""
              render={({ field: { onChange, value } }) => (
                <TextField label="Correo electronico de contacto (Opcional)" onChange={onChange} value={value} />
              )}
            />
            {validationsSectionsErrors[2] ? <BadgeAlertForm /> : null}
          </div>
        </FormSection>

        <FormSection
          title="Artículos"
          helperText="Artículos"
          number={3}
          anyError={validationsSectionsErrors[3]}
          closed={false}
        >
          <div className="w-full flex flex-col gap-4 lg:px-16 lg:py-10">
            <div className="w-full flex flex-col lg:flex-row gap-4">
              <Controller
                name="items_query"
                control={control}
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <TextField label="Buscar artículo..." onChange={onChange} value={value} />
                )}
              />
              <Tooltip content="Buscar" align="top">
                <button
                  type="button"
                  onClick={find_items_action}
                  className={cn(
                    "flex hover:opacity-70 border border-transparent px-4 py-2 rounded-lg cursor-pointer",
                    `bg_${_color} hover:border_${_color}`,
                  )}
                >
                  <IoSearch className="text-xl font-semibold text-white" />
                  <span className="text-white text-base font-medium ml-1">Buscar</span>
                </button>
              </Tooltip>
            </div>
            <div className="flex flex-row items-center justify-start -mt-2 ml-1">
              <Controller
                name="find_by_sku"
                control={control}
                defaultValue={false}
                render={({ field: { onChange, value } }) => (
                  <Checkbox ref={check_query_ref} name="find_by_sku" onSelect={onChange} checked={value} />
                )}
              />
              <label
                className="ml-2 text-sm text-gray-700 cursor-pointer"
                onClick={() => check_query_ref?.current?.click()}
              >
                Búsqueda por SKU
              </label>
            </div>
            <div className="w-full flex flex-col gap-2">
              {selected_items?.length ? (
                <div className="w-full flex flex-col gap-2">
                  {selected_items?.map((item: any) => (
                    <div
                      className="w-full grid grid-cols-1 md:grid-cols-[3fr_1fr_auto] items-start md:items-center gap-4 border-b border-gray-200 pb-4 md:pb-2"
                      key={item?.sku}
                    >
                      <p>
                        <span className="font-semibold italic">{item?.sku}</span>, {item?.name}
                      </p>
                      <TextField
                        label="Cantidad"
                        type="number"
                        className="w-full"
                        onChange={(e: any) => add_qty_item_form(item, e?.target?.value)}
                        value={item?.quantity}
                        min={1}
                      />
                      <TrashButton label="" onClick={() => delete_item_form(item)} />
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-gray-500">No hay artículos seleccionados</p>
              )}
            </div>
            {validationsSectionsErrors[3] ? <BadgeAlertForm /> : null}
          </div>
        </FormSection>
      </div>
      <Modal ref={modal_ref}>
        <div className="flex flex-col min-w-96 max-w-2xl max-h-[600px] lg:w-auto">
          <div className={cn("w-full text-center rounded-t-xl p-2", `bg_${_color}`)}>
            <h4 className="text-lg font-medium uppercase text-white">{`Resultados por: ${items_query}`}</h4>
          </div>
          <div className="w-full flex flex-col rounded-b-xl gap-4 px-4 py-6">
            {loading_schedule ? (
              <p className="text-center">Espere...</p>
            ) : !loading_schedule && available_items.length ? (
              <div className="w-full flex flex-col gap-2 overflow-y-scroll max-h-[450px]">
                {available_items?.map((item: any) => (
                  <div
                    className="w-full flex flex-col items-center md:justify-between md:flex-row gap-4 border-b border-gray-200 pb-2"
                    key={item?.sku}
                  >
                    <p>
                      <span className="font-semibold italic">{item?.sku}</span>, {item?.name}
                    </p>
                    {selected_items?.find((_item: any) => _item?.sku === item?.sku) ? (
                      <TrashButton label="Eliminar" onClick={() => delete_item_form(item)} />
                    ) : (
                      <AddButton label="Agregar" onClick={() => add_item_form(item)} />
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-center text-gray-500">No se encontraron artículos</p>
            )}
            <div className="flex flex-row justify-end items-end">
              <Button label="Ok" onClick={() => modal_ref.current?.close()} />
            </div>
          </div>
        </div>
      </Modal>
    </Fragment>
  )
}

export default FormQuerySchedule
